export const CHANGE_SELECTED_WORKSPACE = "CHANGE_SELECTED_WORKSPACE";
export const CHANGE_WORKSPACE_TIMEZONE = "CHANGE_WORKSPACE_TIMEZONE";
export const UPDATE_ALL_WORKSPACE_LIST = "UPDATE_ALL_WORKSPACE_LIST";
export const ADD_WORKSPACE_TO_WORKSPACE_LIST = "ADD_WORKSPACE_TO_WROKSPACE_LIST";
export const CHANGE_SELECTED_WORKSPACE_STATUS = "CHANGE_SELECTED_WORKSPACE_STATUS"
